"use client";

import { useState } from "react";

import Image from "next/image";

import instagram from "@/../public/instagram.svg";
import linkedin from "@/../public/linkedin.svg";
import spotify from "@/../public/mdi_spotify.svg";
import twitter from "@/../public/twitter-square.svg";
import youtube from "@/../public/youtube.svg";
import ExternalRedirectModal from "@/components/organisms/modals/external-redirect";

export default function Social() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [link, setLink] = useState<string>("");

  const onOpen = (link: string) => {
    setLink(link);
    setIsOpen(true);
  };

  return (
    <div className="flex">
      <ExternalRedirectModal isOpen={isOpen} setIsOpen={setIsOpen} url={link} />
      <Image
        className="size-[36px] cursor-pointer"
        src={instagram}
        alt="instagram"
        onClick={() => onOpen("https://www.instagram.com/harpiodigital/")}
      />
      <Image
        className="size-[36px] cursor-pointer"
        src={linkedin}
        alt="linkedin"
        onClick={() =>
          onOpen("https://www.linkedin.com/company/harpiodigital/")
        }
      />
      <Image
        className="size-[36px] cursor-pointer"
        src={twitter}
        alt="twitter"
        onClick={() => onOpen("https://twitter.com/harpiodigital")}
      />
      <Image
        className="size-[36px] cursor-pointer"
        src={youtube}
        alt="youtube"
        onClick={() => onOpen("https://www.youtube.com/@harpio4423")}
      />
      <Image
        className="size-[36px] cursor-pointer"
        src={spotify}
        alt="spotify"
        onClick={() =>
          onOpen("https://open.spotify.com/show/7zYpF3SedYeSgUNDnFSxX2")
        }
      />
    </div>
  );
}
